(function (_) {
    'use strict';

    angular.module('GorillaBoy')
    .factory('RightsUtil', [function () {

        function RightSet() {
            var _rights = {};
            var _length = 0;

            this.add = function () {
                var i, rightName;

                for (i = 0; i < arguments.length; i += 1) {
                    rightName = arguments[i];
                    _rights[rightName] = rightName;
                    _length += 1;
                }
            };

            this.contains = function (rightName) {
                return !!_rights[rightName];
            };

            this.length = function () {
                return _length;
            };

            this.all = function () {
                var filteredAll = [],
                    rightName;
                for (rightName in _rights) {
                    if (_rights.hasOwnProperty(rightName)) {
                        filteredAll.push(rightName);
                    }
                }

                return filteredAll;
            };
        }

        return {
            newRightSet: function () {
                var i, set;

                set = new RightSet();

                if (arguments.length) {
                    _.forEach(arguments, function (rightName) {
                        set.add(rightName);
                    });
                }

                return set;
            },

            /**
             * Generate predicate function used to filter only rights for a given user.
             */
            rightForUserPredicate: function (username) {
                return function (rightAssignment) {
                    return rightAssignment.User.Username === username;
                };
            }
        };
    }]);
}(_));
